exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".item[data-v-1c65bc54]{-webkit-user-select:none;-ms-user-select:none;user-select:none}.item__title[data-v-1c65bc54]:hover{cursor:pointer}.title__toggle-button[data-v-1c65bc54]{flex:0 0 auto;font-size:1em}.title:hover .title__toggle-button[data-v-1c65bc54]{color:#598ebd}", ""]);

// exports
